module.exports = __webpack_public_path__ + "fonts/intelo-bolditalic.4c4afd6.woff2";